export const isKnownMatchFormat = (format: number | null | undefined): format is 1 | 2 | 3 | 4 | 5 =>
  format === 1 || format === 2 || format === 3 || format === 4 || format === 5

export const isLimitedOversFormat = (format: number | null | undefined): boolean =>
  format === 2 || format === 3 || format === 4 || format === 5

export const hasPositiveOvers = (overs: number | null | undefined): overs is number =>
  typeof overs === 'number' && Number.isFinite(overs) && overs > 0

export const matchSettingsValidationError = (
  format: number | null | undefined,
  maxOvers: number | null | undefined
): string | null => {
  if (!isKnownMatchFormat(format))
    return 'Match format is missing. Check and restore it in Match Settings before scoring.'
  if (isLimitedOversFormat(format) && !hasPositiveOvers(maxOvers)) {
    return 'Limited-overs matches need a positive overs limit. Restore or correct Overs per innings before scoring.'
  }
  return null
}

export const canRestorePrematchOvers = (status: number | null | undefined, inningCount: number): boolean =>
  status === 0 && inningCount === 0
